import React, { useContext, useState, useEffect } from "react";
import { Button, Form, Container, Row, Col } from "react-bootstrap";

import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";

const Dob: React.FunctionComponent<{
  onSubmit?: (value: DOB) => void;
}> = (props: { onSubmit?: (value: DOB) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  useEffect(() => {}, []);

  const handleSubmit = () => {
    if (props.onSubmit) props.onSubmit({ day, month, year });
  };

  const [month, setMonth] = useState<string>(
    loanFormContext.dob ? loanFormContext.dob.value.month : ""
  );
  const [day, setDay] = useState<string>(
    loanFormContext.dob ? loanFormContext.dob.value.day : ""
  );
  const [year, setYear] = useState<string>(
    loanFormContext.dob ? loanFormContext.dob.value.year : ""
  );

  // useEffect(() => {
  //   if (dayTouched && monthTouched && yearTouched) {
  //     handleSubmit({ day, month, year });
  //   }
  // }, [year]);

  return (
    <div>
      <FormStep header={<h1 className="heading-main">When were you born?</h1>}>
        <Container>
          <Row
            className="form-inputs-wrapper c29ahl"
            style={{ maxWidth: "350px" }}
          >
            <Col xs={12} lg={4}>
              <Form.Group controlId="exampleForm.SelectCustom">
                <Form.Label>Month</Form.Label>
                <Form.Control
                  as="select"
                  custom
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                    setMonth(e.target.value)
                  }
                  value={month}
                >
                  <option
                    value="january"
                    selected={month == "january" ? true : false}
                  >
                    January
                  </option>
                  <option
                    value="feburary"
                    selected={month == "feburary" ? true : false}
                  >
                    Februray
                  </option>
                  <option
                    value="march"
                    selected={month == "march" ? true : false}
                  >
                    March
                  </option>
                  <option
                    value="april"
                    selected={month == "april" ? true : false}
                  >
                    April
                  </option>
                  <option value="may" selected={month == "may" ? true : false}>
                    May
                  </option>
                  <option
                    value="june"
                    selected={month == "june" ? true : false}
                  >
                    June
                  </option>
                  <option
                    value="july"
                    selected={month == "july" ? true : false}
                  >
                    July
                  </option>
                  <option
                    value="august"
                    selected={month == "august" ? true : false}
                  >
                    August
                  </option>
                  <option
                    value="september"
                    selected={month == "september" ? true : false}
                  >
                    September
                  </option>
                  <option
                    value="october"
                    selected={month == "october" ? true : false}
                  >
                    October
                  </option>
                  <option
                    value="november"
                    selected={month == "november" ? true : false}
                  >
                    November
                  </option>
                  <option
                    value="december"
                    selected={month == "december" ? true : false}
                  >
                    December
                  </option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={12} lg={4}>
              <Form.Group controlId="exampleForm.SelectCustom">
                <Form.Label>Day</Form.Label>
                <Form.Control
                  as="select"
                  custom
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                    setDay(e.target.value)
                  }
                  value={day}
                >
                  {[...new Array(31)].map((_, i) => (
                    <option
                      value={i + 1}
                      selected={day == (i + 1).toString() ? true : false}
                    >
                      {i + 1}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={12} lg={4}>
              <Form.Group controlId="exampleForm.SelectCustom">
                <Form.Label>Year</Form.Label>
                <Form.Control
                  as="select"
                  custom
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                    setYear(e.target.value)
                  }
                  value={year}
                >
                  {Array.from(
                    Array(new Date().getFullYear() - (1920 + 18)),
                    (_, i) => (i + 1920).toString()
                  )
                    .reverse()
                    .map((y) => {
                      return (
                        <option
                          value={y}
                          selected={year == y.toString() ? true : false}
                        >
                          {y}
                        </option>
                      );
                    })}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={12} className="mt-5">
              <div style={{ maxWidth: 300, margin: "auto" }}>
                <Button variant="primary" block onClick={handleSubmit}>
                  Continue
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </FormStep>
    </div>
  );
};

export type DOB = {
  month: string;
  day: string;
  year: string;
};

export default Dob;
